import React from 'react'
import PropTypes from 'prop-types'
import Phone from '@mui/icons-material/Phone'

const PhoneIcon = ({ height, width, ...more }) => {
	
	return (
		<Phone
			height={height}
			width={width}
			{...more}
		/>
	)
}

PhoneIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default PhoneIcon
